<template>
    <div>
        <base-crud
                crudName="Usuários"
                newText="Novo Usuário"
                :table="userTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                userTable: 'userTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'photo', 'name', 'email', 'actions'],
                tableData: ['id', 'name', 'photo', 'name', 'email'],
                options: {
                    filterByColumn: true,
                    filterable: ['id', 'name', 'name', 'email'],
                    sortable: ['id', 'name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'photo' : 'Foto',
                        'name' : 'Nome',
                        'email' : 'E-mail',
                        'actions' : 'Ações'
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'users/',

                dataForm: {}
            }
        },
        components: {
            BaseCrud
        },
        methods: {
          query: function (query) {
                let columns = {
                    id: 'id',
                    name: 'name',
                    email: 'email'
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
          }
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/User/Crud.vue